import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function FitbitInitialLinkRedirect() {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        window.localStorage.setItem("tryNowToken", "");
        window.localStorage.setItem("tryNowTokenExpires", "");
        window.location.href = searchParams.get('redirect') || '/';
    }, [searchParams]);

    return <main className="redirecting">
        <p>Redirecting...</p>
    </main>;
}
